/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type MessageStatus = 'draft' | 'publishing' | 'published' | 'error' | 'archived';

export const MessageStatus = {
    Draft: 'draft' as MessageStatus,
    Publishing: 'publishing' as MessageStatus,
    Published: 'published' as MessageStatus,
    Error: 'error' as MessageStatus,
    Archived: 'archived' as MessageStatus
};

